module.exports = __webpack_public_path__ + "static/the-middleman-b96f1956188e4156848d42516f8d6ae5.jpg";